.context-menu__wrapper {
  left: 0;
  min-width: 10rem;
  position: fixed;
  top: 0;
  visibility: visible;
  z-index: 1000;
}

.context-menu__button {
  align-items: center;
  background-color: var(--color-grey-300);
  border: 0;
  border-radius: 4px;
  color: var(--color-grey-700);
  display: flex;
  height: 1.35rem;
  justify-content: center;
  position: absolute;
  right: 0.25rem;
  top: -1.6rem;
  width: 1.35rem;
}

.context-menu {
  background-color: var(--color-uva-white);
  border: 1px solid var(--color-grey-500);
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0 0 0 / 20%);
  height: 0;
  list-style-type: none;
  margin: -2px 0 0;
  overflow: hidden;
  padding: 0;
  visibility: hidden;
}

.context-menu--open {
  height: auto;
  visibility: visible;
}

.context-menu__item {
  align-items: center;
  background-color: var(--color-uva-white);
  border: none;
  color: var(--color-uva-black);
  display: flex;
  padding: 0.65rem;
  width: 100%;
}

.context-menu__item:hover {
  background-color: var(--color-grey-300);
}

.context-menu__item-divider {
  border-bottom: 1px solid var(--color-grey-500);
}

.context-menu__wrapper--hidden,
.context-menu__wrapper--hidden .context-menu {
  visibility: hidden;
}
